import { AlloyButton } from 'cat-ecommerce-alloy';
import { useTranslation } from 'react-i18next';
import {
  ERROR_DOMAIN,
  ERROR_PATH
} from '../../../../../constants/errorConstants';
import ExceptionFeedbackBySelector from '../../../../common/Exception/ExceptionFeedbackBySelector';
import PropTypes from 'prop-types';
import { getCookie } from '@app/utils';

const ProductSchematicsErrorFeedback = ({
  onClick,
  showTryAgainButton = false,
  ...props
}) => {
  const [t] = useTranslation();
  const referenceId = getCookie('X-Cat-Pcc-Session-Id');
  const selector = state =>
    state.errors[ERROR_DOMAIN.PDP]?.[ERROR_PATH.SCHEMATICS];

  return (
    <ExceptionFeedbackBySelector selector={selector} {...props}>
      <p>
        {t('SHOPPING_CART_REFERENCE_ID')}: {referenceId}
      </p>
      {showTryAgainButton && (
        <AlloyButton onClick={onClick} buttonType="secondary" size="small">
          {t('TRY_AGAIN')}
        </AlloyButton>
      )}
    </ExceptionFeedbackBySelector>
  );
};

export default ProductSchematicsErrorFeedback;

ProductSchematicsErrorFeedback.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  preventScroll: PropTypes.bool,
  showTryAgainButton: PropTypes.bool
};
